import { FC, } from "react";
import { Server } from "@hostingbv/lib/src/api/partner/models/Server";
import { Card } from "@hostingbv/lib/src/components/Card";

export const VirtualServerDetails: FC<{ server: Server }> = ({ server }) => {
  return <>
    <DetailsBlock server={server} />
  </>
}

function DetailsBlock(props: { server: Server }) {
  return <div className={'mb-12'}>
    <Card title={'Details'}>
      <div className={"flex"}>
        <dl className={"flex-1"}>
          <dt className={"text-slate-500 text-xs"}>Name</dt>
          <dd className={"text-slate-900 mb-4"}>{props.server.displayName}</dd>
          <dt className={"text-slate-500 text-xs"}>Support</dt>
          <dd className={"text-slate-900 mb-4"}>{props.server.managedHosting ? "Managed Wordpress" : (props.server.managedServer ? 'Managed Server' : 'Unmanaged Server')}</dd>
        </dl>
      </div>
    </Card>
  </div>
}
